angular.module('app.api').factory('AdminProfileApi', [
  'api',
  function AdminProfileApi(api) {
    const adminProfileApi = {
      updateAgentSignature: async (id, payload) => {
        return api.post(`user/${id}/signature`, payload)
      },
      getAgentSignature: async id => {
        return api.get(`user/${id}/signature`)
      },
    }
    return adminProfileApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-profile/admin-profile.api.js